import React from 'react'
import {
  SlideContainer,
  SlideDescription,
  SlideType,
  SlideTextContainer,
  SlideTitle,
  SlideImageContainer,
  SlideImageFrame,
  SlideImageIphone,
  SlideImageAndroid,
} from './styles'

import iphoneFrame from 'assets/images/howtobuy/iphone-frame.png'
import androidFrame from 'assets/images/howtobuy/android-frame.png'

interface CarouselSlideContentProps {
  imgSrc: string
  type: string
  title: string
  description: string
}

export default function WalletCarouselSlide({ imgSrc, type, title, description }: CarouselSlideContentProps) {
  function getMobileOperatingSystem() {
    const userAgent = navigator.userAgent || ''

    if (/android/i.test(userAgent)) {
      return 'Android'
    }

    if (/iPhone|iPad|iPod/i.test(userAgent)) {
      return 'iOS'
    }

    return 'unknown'
  }

  const mobileOS = getMobileOperatingSystem()
  const isAndroid = mobileOS === 'Android'

  return (
    <SlideContainer>
      <SlideImageContainer>
        <SlideImageFrame src={isAndroid ? androidFrame : iphoneFrame} />
        {isAndroid ? <SlideImageAndroid src={imgSrc} alt={title} /> : <SlideImageIphone src={imgSrc} alt={title} />}
      </SlideImageContainer>
      <SlideTextContainer>
        <SlideType>{type}</SlideType>
        <SlideTitle>{title}</SlideTitle>
        <SlideDescription>{description}</SlideDescription>
      </SlideTextContainer>
    </SlideContainer>
  )
}
